function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useField, useFormikContext } from 'formik';
import React from 'react';
import { Button, FormGroup, Table } from 'reactstrap';
import Icon from "../common/icon";
import { Error, Label } from "./";
import { t } from "../../services/translator";
import string from "../../services/utils/string";
export default (function (_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      _ref$groupTag = _ref.groupTag,
      groupTag = _ref$groupTag === void 0 ? FormGroup : _ref$groupTag,
      _ref$labelTag = _ref.labelTag,
      labelTag = _ref$labelTag === void 0 ? Label : _ref$labelTag,
      _ref$errorTag = _ref.errorTag,
      errorTag = _ref$errorTag === void 0 ? Error : _ref$errorTag,
      _ref$inputTag = _ref.inputTag,
      inputTag = _ref$inputTag === void 0 ? 'input' : _ref$inputTag,
      _ref$groupProps = _ref.groupProps,
      groupProps = _ref$groupProps === void 0 ? {} : _ref$groupProps,
      _ref$labelProps = _ref.labelProps,
      labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      _ref$errorProps = _ref.errorProps,
      errorProps = _ref$errorProps === void 0 ? {} : _ref$errorProps;

  var _useField = useField({
    name: name
  }),
      _useField2 = _slicedToArray(_useField, 1),
      field = _useField2[0];

  var _useFormikContext = useFormikContext(),
      setFieldValue = _useFormikContext.setFieldValue;

  var GroupTag = groupTag;
  var LabelTag = labelTag;
  var ErrorTag = errorTag;
  var InputTag = inputTag;
  label = labelProps.text || label;

  if (label === undefined) {
    label = name;
  }

  var collection = field.value || [];
  return /*#__PURE__*/React.createElement(GroupTag, groupProps, label && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelTag, _extends({
    name: name,
    size: size
  }, labelProps), /*#__PURE__*/React.createElement("h3", null, typeof label === 'string' ? string.ucfirst(label) : label)), /*#__PURE__*/React.createElement(Button, {
    size: "md",
    className: "bg-transparent border-0 shadow-none",
    onClick: function onClick() {
      collection.unshift([]);
      setFieldValue(name, collection);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "plus-circle"
  }))), collection.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('longitude')), /*#__PURE__*/React.createElement("th", null, t('latitude')), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, collection.map(function (coord, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(InputTag, _extends({
      className: "form-control form-control-sm",
      onChange: function onChange(e) {
        setFieldValue("".concat(name, "[").concat(i, "][0]"), e.target.value);
      },
      value: coord[0] || ''
    }, inputProps))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(InputTag, _extends({
      className: "form-control form-control-sm",
      onChange: function onChange(e) {
        setFieldValue("".concat(name, "[").concat(i, "][1]"), e.target.value);
      },
      value: coord[1] || ''
    }, inputProps))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      color: "warning",
      className: "mt-1 shadow-none",
      onClick: function onClick() {
        collection.splice(i, 1);
        setFieldValue(name, collection);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "times"
    }))));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "shadow-none",
    onClick: function onClick() {
      collection.push([]);
      setFieldValue(name, collection);
    }
  }, t('add'), /*#__PURE__*/React.createElement(Icon, {
    name: "plus-circle",
    className: "ml-2"
  })))), /*#__PURE__*/React.createElement(ErrorTag, _extends({
    name: name
  }, errorProps)));
});